import optimizelySDK from '@optimizely/optimizely-sdk';
import logError from 'utils/logError';
import { createInstance, ReactSDKClient } from '@optimizely/react-sdk';
import { getOptimizelyUserId } from './OptimizelyHelpers';

optimizelySDK.setLogger({
  log(level, message) {
    const { LOG_LEVEL } = optimizelySDK.enums;
    switch (level) {
      case LOG_LEVEL.ERROR:
        logError(message);
        break;
      default:
        break;
    }
  }
});

let instance: ReactSDKClient;

// eslint-disable-next-line import/prefer-default-export
export function getOptimizelyInstance() {
  // disable optimizely on SSR for now; there seem to be some issues with window.document.getElementById() that need to be debugged into
  if (!instance) {
    if (typeof window !== 'undefined') {
      const {
        ipCountry,
        languageRegionCode,
        mobileBrowser,
        optimizelySettings,
        RAILS_ENV,
        store: { user }
      } = global.__AT_DATA__;

      instance = createInstance({
        datafile: optimizelySettings.datafile
      });

      instance.setUser({
        id: getOptimizelyUserId(),
        attributes: { ipCountry, isPro: Boolean(user?.pro), isSignedIn: !!user, locale: languageRegionCode, mobileBrowser, webEnvironment: RAILS_ENV }
      });
    } else {
      instance = {
        activate: () => {},
        isFeatureEnabled: () => {},
        isReady: () => {},
        track: () => {}
      } as unknown as ReactSDKClient;
    }
  }

  return instance;
}
